export function sendTrackingParams({ dataLayer, isView = true }) {
  if (window.utag) {
    if (isView) {
      window.utag.view(dataLayer);
    } else {
      window.utag.link(dataLayer);
    }
  } else {
    // This is necessary because utag.js script is loaded asynchronously
    setTimeout(() => sendTrackingParams({ dataLayer, isView }), 1000);
  }
}

export function trackInteraction(dataParams) {
  const dataLayer = {
    ...dataParams,
    eventType: 'interaction',
  };

  sendTrackingParams({ dataLayer, isView: false });
}

export function trackView(params) {
  const dataLayer = {
    ...params,
  };
  sendTrackingParams({ dataLayer, isView: true });
}
